import { VCheckbox, VCombobox, VTextField } from 'vuetify/lib/components';

// eslint-disable-next-line import/prefer-default-export
export const elementNameToVuetifyComponent = {
  textField: VTextField,
  comboBox: VCombobox,
  checkBox: VCheckbox,
};
